/** Pure helpers for Ace stability result display and polling behaviour. */

import type { AceStabilityTestResult } from "@/services/api/agentReview";

/** Re-publish queued tasks that never start when no other Ace job is running. */
export const STABILITY_QUEUE_STUCK_MS = 120_000;

export function isPartialStabilityRun(result: AceStabilityTestResult): boolean {
  return result.iterations_completed < result.iterations_requested;
}

export function partialStabilityRunMessage(result: AceStabilityTestResult): string {
  const missing = result.iterations_requested - result.iterations_completed;
  return (
    `Partial run — ${result.iterations_completed} of ${result.iterations_requested} ` +
    `iterations completed (${missing} failed). Variance may be unreliable.`
  );
}

export function shouldAutoRequeueStability(args: {
  waitingForWorker: boolean;
  republishAttempted: boolean;
  queueWaitMs: number;
  queueStuckMs?: number;
}): boolean {
  const threshold = args.queueStuckMs ?? STABILITY_QUEUE_STUCK_MS;
  return args.waitingForWorker && !args.republishAttempted && args.queueWaitMs >= threshold;
}

export function formatElapsedMinutes(startedAt: number, now = Date.now()): string {
  const minutes = Math.floor((now - startedAt) / 60_000);
  if (minutes < 1) return "less than 1 min";
  return `${minutes} min`;
}
